import readList from './helpers/read-list';
import {SWITCH_TO_RESOURCE} from '../redux-resource-plugins/switch/types';

const RESOURCE_NAME = 'languages';

export function readLanguages() {
	return readList(RESOURCE_NAME, 'all');
}

export const setLanguage = value => ({
	type: SWITCH_TO_RESOURCE,
	resourceName: RESOURCE_NAME,
	value
});



// WEBPACK FOOTER //
// ./src/client/redux/actions/languages.js